import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/domains/general/api/client';

import { overviewKeys } from './keys';
import type { OverviewConfigResponse } from './types';

export const overviewQueries = {
  config: (perspectiveId: string) =>
    queryOptions({
      queryKey: overviewKeys.config(perspectiveId),
      queryFn: (): Promise<OverviewConfigResponse> => apiFetch('/overview-config'),
      enabled: !!perspectiveId,
    }),
};

export function useOverviewConfig(perspectiveId: string) {
  return useQuery(overviewQueries.config(perspectiveId));
}
